export enum PageChoices {
    HOME = 'home',
    SERVICES = 'services',
    INDUSTRIES = 'industries',
    CLIENTS = 'clients',
    CAREERS = 'careers',
    TEAM = 'team',
    ABOUT = 'about',
    BLOG = 'blog',
  }